// Runtime picker. Loads once at app boot. The chosen impl is exported as
// `api` (typed against the shared Api interface) and `runtime` (for the
// dashboard indicator).
//
// Heuristic: if `window.api` is set by preload, we're in Electron. Otherwise
// we're in a browser. Electron sets the value synchronously during preload
// execution, before any renderer script runs, so this check is reliable.

import type { Api, Runtime } from './types'
import * as electronImpl from './electron'
import * as webImpl from './web'

const isElectron = typeof window !== 'undefined' && typeof window.api === 'object' && window.api !== null

export const runtime: Runtime = isElectron ? 'electron' : 'web'

export const api: Api = isElectron ? (electronImpl.api as Api) : (webImpl.api as Api)
